export const tagsFields = /* GraphQL */ `
  fragment tagsFields on Tags {
    color
    background_color
    text
  }
`
